import styled from '@emotion/styled'

import { typography } from '@arcade/web'
import { Text } from '@cash-design-system/react'
import {
  createTokenizer,
  getTokenizerLinkProps,
  getUniqueKey,
  spacerTokenizer,
  Tokenizer,
  TokenizersRegex,
} from '@cash-web/text-tokenizer'

const LinkText = styled.a<{ typography: keyof typeof typography }>`
  ${props => props.theme.typography[props.typography]};
  color: ${props => props.theme.colors.textProminent};
  cursor: pointer;
  text-decoration: underline;
`

const disclaimerBoldTextTokenizer: Tokenizer = {
  regex: TokenizersRegex.bold,
  toToken([_, text]) {
    const uniqueKey = getUniqueKey()
    return (
      <Text color="textStandard" key={`bold-${uniqueKey}`} typography="labelDefault" as="strong">
        {text}
      </Text>
    )
  },
}

const disclaimerLinkTokenizer: Tokenizer = {
  regex: TokenizersRegex.link,
  toToken: ([, text, href]: string[]) => {
    const uniqueKey = getUniqueKey()
    return (
      <LinkText typography="linkS" href={href} key={`link-${uniqueKey}`} {...getTokenizerLinkProps(href)}>
        {text}
      </LinkText>
    )
  },
}

const disclaimerBoldLinkTokenizer: Tokenizer = {
  regex: /\*\*(.*?)\[(.*?)\]\((.*?)\)(.*?)\*\*/,
  toToken: ([, beforeLink, linkText, href, afterLink]: string[]) => {
    const uniqueKey = getUniqueKey()
    return (
      <Text color="textStandard" key={`bold-link-${uniqueKey}`} typography="labelDefault" as="strong">
        {beforeLink}
        <LinkText typography="labelDefault" href={href} {...getTokenizerLinkProps(href)}>
          {linkText}
        </LinkText>
        {afterLink}
      </Text>
    )
  },
}

const generalTextTokenizer: Tokenizer = {
  regex: /.*/,
  toToken: ([text]: string[]) => {
    const uniqueKey = getUniqueKey()
    return (
      <Text key={`text-${uniqueKey}`} typography="bodyS">
        {text}
      </Text>
    )
  },
}

const disclaimerTextTokenizers = [
  disclaimerBoldLinkTokenizer,
  disclaimerBoldTextTokenizer,
  disclaimerLinkTokenizer,
  spacerTokenizer,
  generalTextTokenizer,
]

export const disclaimerTextTokenizer = createTokenizer(disclaimerTextTokenizers)

export const lineItemsTextTokenizer = createTokenizer([spacerTokenizer])
